import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import { CuttingState, CuttingStatePairs, toString as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { ShipmentState, ShipmentStatePairs, toString as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { ShipmentType, ShipmentTypePairs, toString as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { UserType, UserTypePairs, toString as toStringUserType } from "../../../types/models/UserType.d";
import { CordwoodMeasurementType, CordwoodMeasurementTypePairs, toString as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";

















import { PrimaryProvider } from "../../../../timber/types/models/Provider";

import ProviderFormSelect from "../../../../timber/components/provider/ProviderForm/ProviderFormSelect";












import { t, msg } from "@lingui/core/macro";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import {useLocation} from "react-router";












export const initialFormStateFn = () => { return {
    
        
        email: "",
        
    
        
        name: "",
        
    
        
        description: "",
        
    
        
        userType: UserType.Normal,
        
    
        
        providerId: null,
        
    
    }
}

export const useLocationFormState = () => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    initialFormState.providerId = PrimaryProvider.fromQuery(location.state?.providerId) || null;
    

    

    return React.useMemo(() => initialFormState, [
        location.state,
        
        
    ])
}

export const formObject = {
    
    
        email:
        string()
        .trim()
        .min(1, msg`Email is required`),
    
    
        name:
        string()
        .trim()
        .min(1, msg`Name is required`),
    
    
        description:
        string()
        .trim()
        .nullish(),
    
    
        userType:
        string()
        .trim()
        .min(1, msg`User Type is required`),
    
    
        providerId:
        string()
                .nanoid(msg`Provider is required`)
                .min(1, msg`Provider is required`),
    
};

export const formSchema = object(formObject);

const ProviderUserAddForm = ({watch, prefix = ''})  => {
    return (
        <Container>
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'email' }
       aria-label="email"
       data-testid="email"
       label={t`Email`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'name' }
       aria-label="name"
       data-testid="name"
       label={t`Name`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'description' }
       aria-label="description"
       data-testid="description"
       label={t`Description`}
       
       type='text'
       
   />
   
   
           
           
   
    <crudgen.FormSelect
        required
        name={ prefix + 'userType' }
        aria-label="userType"
        label={t`User Type`}
        options={ UserTypePairs }
        optionLabelMap={ toStringUserType }
    />
   
   
           
           
   
    
    <ProviderFormSelect
        type="dynamicSelect"
        name="providerId"
        label={t`Provider`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
        </Container>
    )
}

export default ProviderUserAddForm;
